var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{ref:"vouchers-modal-ref",attrs:{"id":"vouchers-modal","hide-footer":"","title":"Voucher Information"}},[_c('div',[_c('div',[_c('div',[_c('span',[_vm._v(_vm._s(_vm.voucherInformation))])])])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }